export function normalizeRoleName(role) {
  const value = String(role || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_]/g, "-");
  if (value === "super-admin" || value === "superadmin") return "superadmin";
  if (value === "vaadmin") return "va-admin";
  if (value === "va-distributors") return "va-distributor";
  return value;
}

export function hasRole(roles, roleName) {
  const target = normalizeRoleName(roleName);
  return (Array.isArray(roles) ? roles : []).some(
    (role) => normalizeRoleName(role) === target
  );
}
